
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '',
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            modal: false,
        }
    },
    watch: {
        show(val) {
            this.modal = val
        },
    },
    methods: {
        closeDialog() {
            this.$emit('close', false)
        },
    },
}
